import { xano } from "@/lib/xano";
import { EngineView } from "@/components/EngineView";
import { SectionTitle } from "@/components/shared";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { dateUk } from "@/lib/format";
import type { Connections } from "@/lib/engine-types";

const CATALOG: { provider: string; name: string; blurb: string }[] = [
  { provider: "shopify", name: "Shopify", blurb: "Products, orders and checkout duties." },
  { provider: "quickbooks", name: "QuickBooks", blurb: "Post journals and reconcile the books." },
  { provider: "xero", name: "Xero", blurb: "Post journals and reconcile the books." },
  { provider: "freeagent", name: "FreeAgent", blurb: "Post journals and reconcile the books." },
];

function render(raw: unknown) {
  const d = raw as Connections;
  const byProvider = new Map((d.connections ?? []).map((c) => [c.provider, c]));

  return (
    <>
      <SectionTitle>Your connections</SectionTitle>
      <div className="grid gap-4 md:grid-cols-2">
        {CATALOG.map((item) => {
          const conn = byProvider.get(item.provider);
          const connected = conn?.status === "connected";
          return (
            <Card key={item.provider}>
              <CardContent className="flex items-start justify-between gap-4 p-5">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-medium">{item.name}</span>
                    {connected ? (
                      <Badge variant="success">
                        <CheckCircle2 className="h-3 w-3" /> Connected
                      </Badge>
                    ) : (
                      <Badge variant="secondary">Not connected</Badge>
                    )}
                  </div>
                  <p className="mt-1 text-sm text-muted-foreground">{item.blurb}</p>
                  {connected && (
                    <div className="mt-2 text-xs text-muted-foreground">
                      {conn?.account && <div>Account: {conn.account}</div>}
                      {conn?.last_synced_at && <div>Last synced: {dateUk(new Date(conn.last_synced_at).toISOString())}</div>}
                    </div>
                  )}
                </div>
                <Button variant={connected ? "secondary" : "default"} className="shrink-0">
                  {connected ? "Manage" : "Connect"}
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
      <p className="mt-4 text-xs text-muted-foreground">
        Connect flows wire to the existing OAuth endpoints next. Carriers (Royal Mail, DHL) arrive
        with the shipping label phase.
      </p>
    </>
  );
}

export default function Integrations() {
  return (
    <EngineView
      title="Integrations"
      description="Connect and manage Shopify, QuickBooks, Xero, FreeAgent and (soon) carriers."
      queryKey="connections"
      queryFn={(token) => xano.dashboard.connections(token)}
      render={render}
    />
  );
}
